import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import { Chapter } from './guide-toc-chapter';
import { useTOC } from './toc-hook';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'sticky',
    top: 60,
    overflowY: 'scroll',
  },
  content: {
    paddingTop: 50,
    '& ul': {
      listStyle: 'none',
    },
    '& li': {
      display: 'flex',
      padding: '2px 8px',
      borderRadius: 2,
      cursor: 'pointer',
      '& a': {
        width: '100%',
        color: 'inherit',
      },
      '&:hover': {
        backgroundColor: '#F0C8C8',
      },
    },
  },
  links: {
    paddingTop: 20,
  },
}));

type Props = {
  content: JSX.Element;
};

export const GuideToc = ({ content }: Props) => {
  const classes = useStyles();

  const tocItems = useTOC({ content });

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} className={classes.content}>
        <Typography
          variant="body1"
          component="span"
          color="primary"
          style={{ fontSize: 24, lineHeight: 1 }}
        >
          Obsah
        </Typography>
        <ul className={classes.links}>
          {tocItems.map((item) => (
            <Chapter item={item} key={item.id} />
          ))}
        </ul>
      </Grid>
    </Grid>
  );
};
